import { useSamplesAirMicrobialBaseDataCreateMutation } from "@/services/backend/samples/api/air-microbial-base-data-api";
import { CreateSampleBaseDataDialog } from "@/services/backend/samples/components/create-sample-base-data-dialog";

export function CreateAirMicrobialBaseDataDialog() {
  const mutation = useSamplesAirMicrobialBaseDataCreateMutation();
  return <CreateSampleBaseDataDialog mutation={mutation} />;
}
